module.exports = __webpack_public_path__ + "img/about-bg.30e954e3.png";